import Sidebar from './sidebar'
import MainComponent from './maincontent'
import '../../styles/chat.css'
import { GetChatLog } from '../../services/data'
import { useEffect, useState } from 'react'
import Loader from '../../components/loader'
import MobileViewChat from './mobileview'
import { useSubscription } from '../../context/subscriptionprovider'
import AccessRestrictedOverlay from '../../components/restrictoverlay'
import useChatbotLoader from '../../util/chatbotloader'
import { useLocation, useParams } from 'react-router-dom'

const Chat = () => {
  const [isDataEmpty, setIsDataEmpty] = useState(null)
  const checkdata = new GetChatLog()
  const { isRestricted, limitedPermission } = useSubscription()
  console.log(isRestricted, limitedPermission)
  // useChatbotLoader('', '')
  const location = useLocation()
  const params = useParams()
  
    // ✅ Extract store_id from URL (params or pathname)
    const getStoreIdFromUrl = () => {
      if (params?.store_id) return params.store_id
      const pathParts = location.pathname.split('/')
      console.log(pathParts[1])
      return pathParts[1] || null
    }
  
    const store_id = getStoreIdFromUrl()

  const isAccessRestricted = isRestricted

  useEffect(() => {
    if (isAccessRestricted) return

    const controller = new AbortController()

    const { signal } = controller

    const CheckCustomerId = async id => {
      const res = await checkdata.Get_Customer_List(id, signal)
      if (res.success) {
        setIsDataEmpty(res.data.length === 0)
      } else {
        setIsDataEmpty(true)
      }
    }

    const storeId = store_id
    if (storeId) {
      CheckCustomerId(storeId)
    } else {
      setIsDataEmpty(true)
    }

    return () => {
      controller.abort()
    }
  }, [isAccessRestricted])

  if (isAccessRestricted) {
    return (
      <div className='min-h-[29.1rem] h-full relative'>
        <AccessRestrictedOverlay
          content={
            'Unlock Chat functionality. Upgrade your subscription to enable live interactions with your bot.'
          }
        />
      </div>
    )
  }

  if (isDataEmpty === null) {
    return (
      <div className='min-h-[29.1rem] h-full flex justify-center items-center'>
        <Loader size={24} />
      </div>
    )
  }

  return (
    <div className='min-h-[29.1rem] h-full flex relative w-full'>
      {isDataEmpty ? (
        <div className='flex flex-1 items-center justify-center text-gray-500'>
          No history available
        </div>
      ) : (
        <>
          <div className='block md:hidden lg:hidden w-full'>
            <MobileViewChat />
          </div>
          <div className='hidden md:flex lg:flex w-full px-5'>
            <Sidebar />
            <MainComponent />
          </div>
        </>
      )}
    </div>
  )
}

export default Chat
